import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { LOGIN_URL } from '../utils/commonUtil';

import Menu from '../containers/Menu';

// パスワード
import ChangePassword from '../containers/ChangePassword';

// 各Menuページ
// ロコモ系.
import UserSelectLocomo from '../containers/UserSelectLocomo';
import Locomo from '../containers/Locomo';

// ADL系.
import UserSelectAdl from '../containers/UserSelectAdl';
import Adl from '../containers/Adl';

// 記録系.
import UserSelectKiroku from '../containers/UserSelectKiroku';
import Kiroku from '../containers/Kiroku';

// モフトレ通信系.
import UserSelectPress from '../containers/UserSelectPress';
import PressSelectMonth from '../containers/PressSelectMonth';
import Press from '../containers/Press';

// モフトレチェック系.
import UserSelectMoffCheck from '../containers/UserSelectMoffCheck';
import MoffCheckSelectMonth from '../containers/MoffCheckSelectMonth';
import MoffCheck from '../containers/MoffCheck';

// 居宅訪問.
import HomeVisit from '../containers/HomeVisit';
import HomeVisitPrint from '../containers/HomeVisitPrint';

// 機能訓練レポート.
import UserSelectLiterallyReport from '../containers/UserSelectLiterallyReport';
import LiterallyReportSelectMonth from '../containers/LiterallyReportSelectMonth';

// import MoffAPITest from '../containers/MoffAPITest';
// 興味関心チェック系.
import UserInterestCheck from '../containers/UserInterestCheck';
import InterestCheckPrint from '../containers/InterestCheckPrint';

export default class Routes extends React.Component {

  render() {
    return (
      <Switch>
        {/* メニュー画面 */}
        <Route path={LOGIN_URL} component={Menu} />
        {/* ロコモ予防トレーニング */}
        <Route path="/user_select_locomo" component={UserSelectLocomo} />
        {/* ロコモ予防トレーニング/詳細 */}
        <Route path="/locomo/:userId" component={Locomo} />
        {/* 日常生活動作トレーニング */}
        <Route path="/user_select_adl" component={UserSelectAdl} />
        {/* 日常生活動作トレーニング/詳細 */}
        <Route path="/adl/:userId" component={Adl} />
        {/* 個別機能訓練に関する記録 */}
        <Route path="/user_select_kiroku" component={UserSelectKiroku} />
        {/* 個別機能訓練に関する記録/詳細 */}
        <Route path="/kiroku/:userId" component={Kiroku} />
        {/* モフトレ通信 */}
        <Route path="/user_select_press" component={UserSelectPress} />
        {/* モフトレ通信/月選択画面 */}
        <Route path="/press_select_month/:userId" component={PressSelectMonth} />
        {/* モフトレ通信/詳細 */}
        <Route path="/press/:userId/:yearMonth" component={Press} />
        {/* モフトレチェック */}
        <Route path="/user_select_moff_check" component={UserSelectMoffCheck} />
        {/* モフトレチェック/月選択画面 */}
        <Route path="/moff_check_select_month/:userId" component={MoffCheckSelectMonth} />
        {/* モフトレチェック/詳細*/}
        <Route path="/moff_check/:userId/:yearMonth" component={MoffCheck} />
        {/* 居宅訪問 */}
        <Route path="/home_visit" component={HomeVisit} />
        {/* 居宅訪問 */}
        <Route path="/home_visit_print/:total/:uniqueId/:userId" component={HomeVisitPrint} />
        {/* 興味関心チェック */}
        <Route path="/user_interest_check" component={UserInterestCheck} />
        {/* 興味関心チェック/詳細 */}
        <Route path="/interest_check_print/:total/:uniqueId/:userId" component={InterestCheckPrint} />
        {/* 機能訓練レポート */}
        <Route path="/user_select_literally_report" component={UserSelectLiterallyReport} />
        {/* 機能訓練レポート/月選択画面 */}
        <Route path="/literally_report_select_month/:userId" component={LiterallyReportSelectMonth} />

        {/* モフトレパスワード変更画面 */}
        <Route path="/change_password.html" component={ChangePassword} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Routes.tsx